import { Serializable, StarbaseEntity} from 'starbase-launcher';
import { ImageFile } from './imageFile';
import { RelatedSetTypeEnum } from './relatedSetModel';

export class RelatedImageSetViewDataModel implements Serializable<RelatedImageSetViewDataModel> {
  //TODO: UPDATE TO USE RelatedImageSetViewDataModel.Relatedsetuid or find a way to clarify
  public uid: number;

  public name: string;

  public thumbnailImage: ImageFile;

  public imageCount: number;

  public stackFrontImageUID: number;

  public imageNames: string[];

  public matchedRecords: number;

  public setType: RelatedSetTypeEnum;

  deserialize(input) {
    return Object.assign(new RelatedImageSetViewDataModel(), input);
  }
}
